import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertaComponent } from './components/alerta/alerta.component';

@NgModule({
  declarations: [AlertaComponent],
  imports: [CommonModule],                 // << necesario para [ngClass], *ngIf, *ngFor
  exports: [CommonModule, AlertaComponent] // << exporta para usar <app-alerta> en otros módulos
})
export class SharedModule {}
